module.exports = __webpack_public_path__ + "media/images/shared/ad/acofes2016_bnr-96a9ada65a63c7497af7e9152941271d.jpg";